import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {
    FaArrowRight, FaRegClock, FaRegLightbulb,
    FaLayerGroup, FaCogs, FaComments,
} from "react-icons/fa";
import { getImage } from "../../utils/podcastClubUtils";
import "../../styles/ListenerDashboard.scss";

const fmtDate = (d) =>
    d ? new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : null;

const ListenerPortfolioPodcastClub = ({ club, linkTo }) => {
    const navigate = useNavigate();
    const img = getImage(club, 'super_wide') || getImage(club, 'tall');

    return (
        <div className="ld-club-card card">

            {/* ── Left image ── */}
            {img
                ? <img src={img} alt={club.title} className="ld-club-card__img" />
                : <div className="ld-club-card__img-placeholder" />
            }

            {/* ── Right body ── */}
            <div className="ld-club-card__body">

                <div className="ld-club-card__title">{club.title}</div>

                {club.description && (
                    <p className="ld-club-card__desc">{club.description}</p>
                )}

                {/* Stat pills */}
                <div className="ld-club-card__stats">
                    {club.episodes_count > 0 && (
                        <span className="ld-stat-pill">
                            <FaLayerGroup />
                            {club.episodes_count} ep{club.episodes_count !== 1 ? 's' : ''}
                        </span>
                    )}
                    {club.key_takeaways_count > 0 && (
                        <span className="ld-stat-pill ld-stat-pill--gold">
                            <FaRegLightbulb />
                            {club.key_takeaways_count} insight{club.key_takeaways_count !== 1 ? 's' : ''}
                        </span>
                    )}
                    {club.practices_count > 0 && (
                        <span className="ld-stat-pill ld-stat-pill--green">
                            <FaCogs />
                            {club.practices_count} practice{club.practices_count !== 1 ? 's' : ''}
                        </span>
                    )}
                    {club.discussions_count > 0 && (
                        <span className="ld-stat-pill">
                            <FaComments />
                            {club.discussions_count} discussion{club.discussions_count !== 1 ? 's' : ''}
                        </span>
                    )}
                </div>

                {/* Footer: date + CTA */}
                <div className="ld-club-card__footer">
                    <div className="ld-club-card__date">
                        {fmtDate(club.start_date_time) && (
                            <>
                                <FaRegClock />
                                {fmtDate(club.start_date_time)}
                            </>
                        )}
                    </div>
                    <OverlayTrigger placement="top" overlay={<Tooltip>Open club</Tooltip>}>
                        <Button
                            variant="primary"
                            size="sm"
                            onClick={() => navigate((linkTo ?? '/listener-podcast-club/') + club.guid)}
                        >
                            Open <FaArrowRight className="ms-1" />
                        </Button>
                    </OverlayTrigger>
                </div>

            </div>
        </div>
    );
};

export default ListenerPortfolioPodcastClub;
